import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
  ReactNode,
} from "react";

import { useSocket } from "./SocketContext";
import { QuickReply } from "../types/message";
import { loadAllQuickReplies } from "../api/quickReplies";

interface QuickReplyContextType {
  quickReply: QuickReply[];
  loading: boolean;
  loadAllQuick: () => Promise<void>;
}

const QuickReplyContext = createContext<QuickReplyContextType | null>(null);

export const QuickReplyProvider = ({ children }: { children: ReactNode }) => {
  const [quickReply, setQuickReply] = useState<QuickReply[]>([]);
  const [loading, setLoading] = useState(false);

  const loadAllQuick = useCallback(async () => {
    if (loading) return;

    try {
      setLoading(true);
      const response = await loadAllQuickReplies(2);
      setQuickReply(response ?? []);
    } finally {
      setLoading(false);
    }
  }, [loading]);



  /* ---------------- SIGNALR (opcional futuro) ---------------- */
  const { subscribeEvent } = useSocket();

  React.useEffect(() => {
    const unsub = subscribeEvent<{ quickReply: QuickReply[] }>(
      "QuickReplyUpdated",
      (data) => {
        console.log("[QuickReplyContext] QuickReplyUpdated", data.quickReply);
        setQuickReply(data.quickReply);
      }
    );

    return () => unsub();
  }, [subscribeEvent]);

  const value = useMemo(
    () => ({
      quickReply,
      loading,
      loadAllQuick,
    }),
    [quickReply, loading, loadAllQuick]
  );

  return (
    <QuickReplyContext.Provider value={value}>
      {children}
    </QuickReplyContext.Provider>
  );
};

export const useQuickReply = () => {
  const ctx = useContext(QuickReplyContext);
  if (!ctx) {
    throw new Error("useQuickReply must be used inside QuickReplyProvider");
  }
  return ctx;
};
